<template>
  <div>
    <template
      v-if="winStreak !== null"
    >
      <table
        class="prop-table mb-4"
      >
        <tr>
          <th>Type</th>
          <td>{{winStreak.type.name}}</td>
        </tr>
        <tr>
          <th>Status</th>
          <td
            :class="getWinStreakStatusClass(winStreak.status)"
          >
            {{winStreak.status | getWinStreakStatusName}}
        </td>
        </tr>
        <tr>
          <th>Client min version</th>
          <td>{{winStreak.clientMinVersion | convertOptionalVersionCodeToStr('not specified')}}</td>
        </tr>
        <tr>
          <th>Audience</th>
          <td>{{winStreak.audienceId | getAudienceName}}</td>
        </tr>
        <tr>
          <th>Created at</th>
          <td>{{winStreak.ctime | getMomentStr}}</td>
        </tr>
        <tr>
          <th>Planned start</th>
          <td>{{winStreak.stime | getMomentStr}}</td>
        </tr>
        <tr>
          <th>Real start</th>
          <td>{{winStreak.srtime | getWinStreakRealStartTimeStr}}</td>
        </tr>
      </table>
    </template>

    <p v-if="message !== null">
      {{message}}
    </p>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';

import { getWinStreakStatusName       } from '../model/win-streak.js';
import { getWinStreakStatusClass      } from '../model/win-streak.js';
import { getWinStreakRealStartTimeStr } from '../model/win-streak.js';

import { getAudienceName } from '../util.js';

import LoadingIndicator from './LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'WinStreakInfo',

  components: {
    LoadingIndicator,
  },

  props: {
    winStreakId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,
      winStreak: null,
    };
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    message() {
      if(this.isLoadedNormal && this.winStreak === null) {
        return `Win streak event with id ${this.winStreakId} does not exist.`;
      }
      return null;
    },
  },

  created() {
    this.loadWinStreak();
  },

  methods: {
    loadWinStreak() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = `/win_streak/${this.winStreakId}/info`;
      HTTP.get(url)
      .then(response => {
        this.winStreak = response.data.data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    getWinStreakStatusClass,
  },

  filters: {
    getAudienceName,
    getWinStreakStatusName,
    getWinStreakRealStartTimeStr,
  },
};
</script>
